import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { DashboardPanel } from '../../models/panel';

@Component({
    selector: 'app-menu-panel',
    imports: [CommonModule ],
    templateUrl: './menu-panel.component.html',
    styleUrl: './menu-panel.component.scss'
})
export class MenuPanelComponent {
@Input() paneles:DashboardPanel[]=[];

@Output() closeListener:EventEmitter<any>= new EventEmitter<any>();
 showMenu=false;
constructor(private eRef: ElementRef){
}

@HostListener('document:click', ['$event'])
  clickOut(event: any) {
    if(!this.eRef.nativeElement.contains(event.target))
    this.showMenu=false;
  }

  showPanel(element:any){
    
    this.closeListener.emit(element);

  }
}
